import { INCIDENT_LLM_MODEL } from "@me8eon/config";
import { createIncident } from "./incidentsApi";
import { Message } from "../components/ai/ai.types";
import { incidentPromptTemplate } from "../Ai-incidents/ai/incidentsprompttemplate";
import { aiConfig } from "..";
import { openAiClientForIncidents } from "../Ai-incidents/ai/aiclientforincidents";
import { translateKey } from "../util/translate";
import { getAssignmentGroupFromElasticsearch } from "./assignmentGroupElasticUtil";
import { IncidentFileAttachmentType } from "../components/ai-assist-refactored/AiAssist.context";

export const raiseIncident = async (description: string, contactNumber: string, incidentFiles?: IncidentFileAttachmentType[]) => {
    const messages: Message[] = [
        { role: "system", content: incidentPromptTemplate },
        { role: "user", content: description },
    ];
    const incidentsAiConfig = {
        ...aiConfig,
        customisation: {
            ...aiConfig.customisation,
            model: INCIDENT_LLM_MODEL,
        },
    };
    const incdientsClient = openAiClientForIncidents(incidentsAiConfig);
    const Output = await incdientsClient(messages);
    const finalText = Output?.[Output.length - 1]?.content?.trim();
    const { jwtTokenFn } = aiConfig;
    const assignGroupProd = translateKey("chatBot.assignmentGroupForTicket", "eon-uk-gsd");
    const assignGroup = (await getAssignmentGroupFromElasticsearch(finalText, jwtTokenFn)) || assignGroupProd;

    const shortDescription = "MyHelp - " + finalText;
    const payload = {
        contact_number: contactNumber,
        service: "",
        short_description: shortDescription,
        description: description,
        external_ticket_id: "INF192344",
        category: "User Service Request",
        sub_category: "Degraded/Service",
        contact_type: "Self-Service",
        location_id: "",
        configuration_item: "DECT Manager",
        assignment_group: assignGroup,
        file_name: incidentFiles && incidentFiles.length > 0 ? incidentFiles[0].file_name : "",
        file_data: incidentFiles && incidentFiles.length > 0 ? incidentFiles[0].file_data : "",
    };

    try {
        const response = await createIncident(payload, jwtTokenFn);
        return {...response, short_description: shortDescription};
    } catch (e) {
        console.log(e);
    }
};
